module.exports = __webpack_public_path__ + "media/application/images/icons/icon-buyer-23a11f0b5f67aeb89bb99fb070b737d2.svg";